import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { expandTheme } from 'utils/theme-util';

export const cpStyle = (theme: Theme) => {
  const { palette } = expandTheme(theme);
  return createStyles({
    gridContainer: {
      paddingTop: theme.spacing(3),
      paddingLeft: theme.spacing(2),
    },
    addButton: {
      alignSelf: 'end',
      backgroundColor: palette.primary.teal,
      color: palette.primary.white,
      textTransform: 'none',
    },
    exportButton: {
      alignSelf: 'end',
      backgroundColor: palette.primary.white,
      color: palette.primary.black,
      textTransform: 'none',
    },
    searchField: {
      paddingLeft: '30px',
      marginTop: '5px',
    },
    roundedGrayBackground: {
      backgroundColor: theme.palette.grey[300],
      borderRadius: theme.spacing(1.25),
      marginTop: 5,
      paddingRight: theme.spacing(1.25),
      paddingLeft: theme.spacing(1.25),
      paddingTop: theme.spacing(0.2),
      paddingBottom: theme.spacing(0.2),
      marginRight: theme.spacing(1),
      float: 'left',
    },
    lastCell: {
      'paddingRight': 0,
      'paddingLeft': 0,
      'textAlign': 'left',
      'maxWidth': '50px',
      'width': '50px',
      '&:last-child': {
        paddingRight: 0,
        paddingLeft: 0,
        maxWidth: '0px',
        width: '0px',
      },
    },
    lastCellEmpty: {
      '&:last-child': {
        paddingRight: 0,
        paddingLeft: 0,
      },
    },
    wrapText: {
      '& p': {
        whiteSpace: 'normal',
      },
    },
    parentDataCell: {
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(0),
      textAlign: 'right',
    },
    dataCell: {
      padding: '30px',
    },
    childRow: {
      paddingLeft: '0px',
      paddingRight: '0px',
    },
    accordionheader: {
      backgroundColor: palette.primary.teal,
      marginTop: theme.spacing(0.8),
    },
    innerAccordionheader: {
      backgroundColor: theme.palette.grey[300],
      marginTop: theme.spacing(0.8),
    },
    accordionTitle: {
      color: palette.primary.white,
    },
    innerAccordionTitle: {
      color: palette.primary.black,
    },
    AccordionDetails: {
      backgroundColor: theme.palette.grey[300],
      textAlign: 'left',
    },
    AccordionDetailsForm: {
      backgroundColor: palette.primary.white,
    },
    AccordionDetailsContainer: {
      marginBottom: '12px',
    },
    subTitleInfo: {
      fontWeight: 500,
    },
    valueInfo: {
      fontWeight: 400,
    },
    expandIconColor: {
      color: palette.primary.white,
    },
    innerExpandIconColor: {
      color: palette.primary.black,
    },
    titleWrp: {
      paddingBottom: 0,
    },
    title: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(1),
      fontWeight: 600,
    },
    actionsWrp: {
      padding: theme.spacing(4, 0, 3),
      margin: theme.spacing(0, 3),
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    customerProfileForm: {
      marginTop: theme.spacing(3),
    },
    subSectionTitle: {
      'marginTop': theme.spacing(3),
      'marginBottom': theme.spacing(3),
      '& span': {
        fontWeight: 500,
      },
    },
    rowMarginTop: {
      marginTop: theme.spacing(0.5),
    },
    rowMarginTop2: {
      marginTop: theme.spacing(3),
    },
    centerIcon: {
      display: 'flex',
      justifyContent: 'right',
      cursor: 'pointer',
      marginTop: theme.spacing(2),
    },
    dynamicButtons: {
      'marginTop': theme.spacing(2),
      '& span': {
        color: palette.primary.black,
      },
    },
    dividerLine: {
      marginTop: theme.spacing(4.5),
    },
    missingInfoContainer: {
      marginBottom: theme.spacing(2),
    },
    missingInfoBox: {
      textAlign: 'right',
      backgroundColor: '#fff2f0',
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      borderRadius: 4,
    },
    missingInfoBoxTitle: {
      color: palette.primary.valenciaRed,
    },
    missingInfoRow: {
      textDecoration: 'underline',
      fontWeight: 400,
      color: palette.primary.trellisBlue,
    },
    talkdeskLogo01: {
      height: 250,
      weight: 250,
      display: 'block',
      margin: '0 auto',
    },
    talkdeskLogo02: {
      height: 350,
      weight: 350,
      display: 'block',
      margin: '0 auto',
    },
    talkdeskLinesTitle: {
      fontWeight: 450,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    talkdeskLinesSubTitle: {
      fontWeight: 450,
      marginTop: theme.spacing(1),
    },
  });
};
